define([
    'react',
    'lodash',
    './styles.less'
], function (React, _, Styles) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': Styles.easPagination }, React.createElement('span', {}, 'Pager'), React.createElement('input', {
            'className': Styles.formControl,
            'value': this.state.currentPage,
            'onChange': this.onValueChange
        }), React.createElement('span', { 'className': 'cmn-total-pages' }, 'of ', this.state.totalPages), React.createElement('span', {
            'className': this.getPrevPageClass(),
            'onClick': this.onPrevPage
        }), React.createElement('span', {
            'className': this.getNextPageClass(),
            'onClick': this.onNextPage
        }));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-pager/table-pager/table-pager.rt
 ** module id = 195
 ** module chunks = 0
 **/